<template>
	<div class="backend-title bg-text4">
		{{title}}
	</div>
</template>

<script>
export default {
	props: ["title"],
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.backend-title {
	width: 100%;
	padding: 15px 15px;
	font-size: 36px;
	margin-bottom: 20px;
}
</style>